import { useState } from "react";

import { Button, Modal, Textarea, Typography } from "neetoui";
import { Trans, useTranslation } from "react-i18next";

const BulkOptionModal = ({
  isOpen,
  onClose,
  handleBulkAdd,
  bulkAddHelpDocUrl,
}) => {
  const { t } = useTranslation();
  const [optionsString, setOptionsString] = useState("");

  const handleSave = () => {
    handleBulkAdd(optionsString);
    handleClose();
  };

  const handleClose = () => {
    setOptionsString("");
    onClose();
  };

  return (
    <Modal {...{ isOpen }} onClose={handleClose}>
      <Modal.Header>
        <Typography style="h3">
          {t("neetoMolecules.optionFields.bulkOption.title")}
        </Typography>
      </Modal.Header>
      <Modal.Body>
        <Textarea
          className="my-2"
          data-testid="bulk-add-options-textarea"
          label={t("neetoMolecules.optionFields.bulkOption.label")}
          placeholder={t("neetoMolecules.optionFields.bulkOption.label")}
          rows={8}
          value={optionsString}
          helpText={
            <Trans
              i18nKey="neetoMolecules.optionFields.bulkOption.helpText"
              components={{
                Link: (
                  <Button
                    className="text-xs"
                    href={bulkAddHelpDocUrl}
                    style="link"
                    target="_blank"
                  />
                ),
              }}
            />
          }
          onChange={e => setOptionsString(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer className="flex items-center gap-x-2">
        <Button
          data-testid="bulk-add-options-done-button"
          label={t("neetoMolecules.common.actions.submit")}
          onClick={handleSave}
        />
        <Button
          data-testid="bulk-add-options-cancel-button"
          label={t("neetoMolecules.common.actions.cancel")}
          style="text"
          onClick={handleClose}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default BulkOptionModal;
